import { Injectable, Injector } from '@angular/core';
import { MenuModel } from '../models/menu.model';

@Injectable()
export class MenuService {

    protected menus: Array<MenuModel> = [];

    public constructor(private injector: Injector) {
    }

    /**
     * Deprecated add method.
     *
     * @param {string} name
     * @returns {MenuModel}
     */
    public register(name: string): MenuModel {
        return this.add(name);
    }

    /**
     * Add a new menu item.
     *
     * @param {string} name
     * @returns {MenuModel}
     */
    public add(name: string): MenuModel {
        if (this.exists(name)) {
            throw new Error('Menu\'s with the same name\'s (' + name + ') are not allowed');
        }

        const item = new MenuModel(name, '', '', {}, this.injector);
        this.menus.push(item);

        return item;
    }

    /**
     * Get the menu item with the given name.
     *
     * @param {string} name
     * @returns {MenuModel}
     */
    public get (name: string): MenuModel {
        return this.menus.find(menu => menu.name === name);
    }

    /**
     * Indicates if the menu item with the given name exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    public exists(name: string): boolean {
        return !!this.get(name);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/menu/services/menu.service.ts